// import React from 'react';
// import { Tag } from 'antd';
// const colorMap = {
//   PENDING: 'orange', SETTLED: 'green', PARTIAL: 'blue', CLOSED: 'green',
//   ACTIVE: 'blue', GENERATED: 'green', ADVANCE: 'purple',
//   WAREHOUSE: 'cyan', SCRAP: 'red',
// };
// export default function StatusBadge({ status }) {
//   return <Tag color={colorMap[status] || 'default'} style={{ fontFamily: 'var(--font-mono)', fontSize: 11 }}>{status}</Tag>;
// }

import React from 'react';
import { Tag } from 'antd';
const colorMap = {
  // Item-return status (on Rental)
  PENDING:        'orange',
  PARTIAL:        'blue',
  ITEM_RETURNED:  'green',
  // Payment status (on Rental / RentalReturn)
  CLOSED:         'green',
  ADVANCE:        'purple',
  // Other
  ACTIVE:     'blue',
  GENERATED:  'green',
  SETTLED:    'green',
  WAREHOUSE:  'cyan',
  SCRAP:      'red',
};
export default function StatusBadge({ status }) {
  const label = status === 'ITEM_RETURNED' ? 'RETURNED' : status;
  return <Tag color={colorMap[status] || 'default'} style={{ fontFamily: 'var(--font-mono)', fontSize: 11 }}>{label}</Tag>;
}